import React, { Component, useState } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../../styles/layout/NavMenu.css';
import AndritzLogo from '../../assets/images/andritz-logo-icon.svg';
import Clearfix from './Clearfix';
import ReleaseNotes from "../modals/ReleaseNotes";
import HelpDropdownMenu from "../elements/HelpDropdownMenu";

const NavMenu = () => {
    const [collapsed, setCollapsed] = useState(true);  
    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };
    const [showReleaseNotes, setShowReleaseNotes] = useState(false);
    return (
        <header>
            <div className="logo-bar">
                <img src={AndritzLogo} />
                <p className="system-name">Object Search</p>
                <p className="system-version">Version 2.1.0 Released 11.08.2022</p>
            </div>
            <Clearfix />
            <Navbar className="navbar navbar-expand-sm link-bar">
                <div className="help-button">
                    <HelpDropdownMenu showReleaseNotes={() => setShowReleaseNotes(true)} />
                </div>
                <ReleaseNotes show={showReleaseNotes} setShow={setShowReleaseNotes} t />
                </Navbar>
        </header>
    );
  }
export default NavMenu;
